import { DATA_TABLE_COMMON_NAMESPACE } from '@frontends/data-table';
import { DS_COMMON_NAMESPACE } from '@frontends/ds';
import { FEATURE_SPG_AUTH_NAMESPACE } from '@frontends/feature-spg-auth';
import { FEATURE_SPG_BOTS_NAMESPACE } from '@frontends/feature-spg-bots';
import { FEATURE_SPG_CHANNELS_NAMESPACE } from '@frontends/feature-spg-channels';
import { FEATURE_SPG_DECISIONS_NAMESPACE } from '@frontends/feature-spg-decisions';
import { FEATURE_SPG_ENTRY_FLOWS_NAMESPACE } from '@frontends/feature-spg-entry-flows';
import { FEATURE_SPG_INSTANCES_NAMESPACE } from '@frontends/feature-spg-instances';
import { FEATURE_SPG_PARTICIPANTS_NAMESPACE } from '@frontends/feature-spg-participants';
import { FEATURE_SPG_RETENTION_RULES_NAMESPACE } from '@frontends/feature-spg-retention-rules';
import { FORM_COMMON_NAMESPACE } from '@frontends/form';
import { UI_KIT_NAMESPACE } from '@frontends/ui-kit';
import { UI_SPG_LAYOUT_NAMESPACE } from '@frontends/ui-spg-layout';
import { FALLBACK_LANGUAGE } from '@frontends/util-i18n';
import { createInstance, type i18n as I18n } from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// English only. initI18n would start in the language of the client apps' root-domain locale cookie.
const i18n: I18n = createInstance();

void i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: FALLBACK_LANGUAGE,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [FALLBACK_LANGUAGE],
    load: 'currentOnly',
    ns: [
      'translation',
      DS_COMMON_NAMESPACE,
      UI_KIT_NAMESPACE,
      DATA_TABLE_COMMON_NAMESPACE,
      FEATURE_SPG_AUTH_NAMESPACE,
      FEATURE_SPG_BOTS_NAMESPACE,
      FEATURE_SPG_CHANNELS_NAMESPACE,
      FEATURE_SPG_DECISIONS_NAMESPACE,
      FEATURE_SPG_ENTRY_FLOWS_NAMESPACE,
      FEATURE_SPG_INSTANCES_NAMESPACE,
      FEATURE_SPG_PARTICIPANTS_NAMESPACE,
      FEATURE_SPG_RETENTION_RULES_NAMESPACE,
      FORM_COMMON_NAMESPACE,
      UI_SPG_LAYOUT_NAMESPACE,
    ],
    defaultNS: 'translation',
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
